import React from 'react'

import { Box, Typography } from '@mui/material'

export default function nameColumn() {

	return {
		name: 'name',
		label: 'Report Name',
		options: {
			filterType: 'textField',
			headerAlign: 'left',
			customBodyRowRenderLite: (value) => (
				<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'start' }}>
					<Typography sx={{ fontWeight: 'bold' }}>{value}</Typography>
				</Box>
			)
		}
	}
}
